
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getProjectAnlageTypesEnumFormGroup() {
return new FormGroup({
})
;
}
      